import React, { useContext, useEffect, useRef, useState } from "react";
import {
  MyBookPanditCategoryAPI,
  MyBookPanditPujaListAPI,
} from "../../ApiServices/BookPanditAPI/BookPanditAPI";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import "./BookPandit.css";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import {
  LoaderContext,
} from "../../AuthContext/AuthContext";
import Select from "react-select";
import Breadcrumbs from "../../Components/Breadcrumb";
import { customSelectStyles } from "../../middlewares/Utils";

const BookPandit = () => {
  const [myBookPanditData, setMyBookPanditData] = useState([]);
  const [pujaListData, setPujaListData] = useState([]);
  const [catID, setCatID] = useState(null);
  const [search, setSearch] = useState("");
  const [selectedCatId, setSelectedCatId] = useState(null);
  const { setLoader, loader, pujaStatus, setPujaStatus } =
    useContext(LoaderContext);
  const user_id = localStorage.getItem("userID");
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState(
    pujaStatus === null ? false : pujaStatus
  );
  const [myBookPanditDataMobile, setMyBookPanditDataMobile] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const categoryListRef = useRef(null);
  const productListRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);



  }, []);





  useEffect(() => {

    if (catID !== null && catID !== undefined && catID !== "") {
      const ID = status ? 1 : 2;
      if (!isMobile) {
        GetMyBookPanditCategoryData();

      }
      GetMyBookPanditPujaListData(ID);
    }
  }, [catID, pujaStatus, status]);


  useEffect(() => {
    if (
      location?.state?.selectedCat !== null &&
      location?.state?.selectedCat !== undefined
    ) {
      setCatID(location?.state?.selectedCat);
      setSelectedCatId(location?.state?.selectedCat);
    }


  }, [location]);

  useEffect(() => {

    if (location?.pathname === "/services/online-puja/pitru-paksha-puja") {
      setPujaStatus(true)
      setStatus(true)
      setSelectedCatId(43)
      setCatID(43)
      sessionStorage.setItem("selectedCatId", 43);
    } else if (location?.pathname === "/services/online-puja/brahmin-bhoj") {
      setPujaStatus(true)
      setStatus(true)
      setSelectedCatId(44)
      setCatID(44)
      sessionStorage.setItem("selectedCatId", 44);
    } else {
      GetMyBookPanditCategoryData();
    }
  }, [])

  const GetMyBookPanditCategoryData = async () => {
    setLoader(true);
    const response = await MyBookPanditCategoryAPI(user_id);

    try {
      if (
        response.ResponseMessage === "list" &&
        response.ResponseCode === "0"
      ) {

        const Data = response.DATA;
        let filteredData = [];
        if (status) {
          filteredData = Data?.filter(
            (val) => val?.OnlinePujaCount > 0
          );
          setMyBookPanditData(filteredData);
        } else {
          filteredData = Data?.filter(
            (val) => val?.OfflinePujaCount > 0
          );
          setMyBookPanditData(filteredData);
        }

        const options = filteredData
          .filter((item) => item.PUJACAT_ID && item.PUJACAT_NAME)
          .map((item) => ({
            value: item.PUJACAT_ID,
            label: item.PUJACAT_NAME,
          }));

        setMyBookPanditDataMobile(options);

        const storedCatId = sessionStorage.getItem("selectedCatId");
        const isExist = options?.some(
          (option) => Number(option?.value) === Number(storedCatId)
        );

        if (isExist) {
          if (
            storedCatId !== null &&
            storedCatId !== undefined &&
            Number(storedCatId) > 0
          ) {
            setCatID(Number(storedCatId));
            setSelectedCatId(Number(storedCatId));
          } else {
            setCatID(filteredData[0]?.PUJACAT_ID);
            setSelectedCatId(filteredData[0]?.PUJACAT_ID);
          }
        } else {
          setCatID(filteredData[0]?.PUJACAT_ID);
          setSelectedCatId(filteredData[0]?.PUJACAT_ID);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetMyBookPanditPujaListData = async (requestedFilter) => {
    setLoader(true);
    try {
      const response = await MyBookPanditPujaListAPI(user_id, catID, {
        START: 1,
        END: 1000,
        WORD: "None",
        LATITUDE: "20.008581",
        LONGITUDE: "73.76413099999999",
      });

      if (response) {
        setLoader(false);
        const filteredData = response?.DATA?.filter(
          (value) =>
            value.PoojaTypeID === requestedFilter ||
            value.PoojaTypeID === 3
        );
        setPujaListData(filteredData);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const viewDetail = (product) => {
    const newSlug = product?.PujaSlug;
    if (catID) {
      sessionStorage.setItem("selectedCatId", catID);
    }
    navigate(`/services/book-puja/${newSlug}`, {
      state: { product: product, PujaStatus: status ? 1 : 2 },
    });
  };

  const ProductCard = ({ product }) => (
    <div
      className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 product-item-one"
      style={{
        marginBottom: "15px",
        width: "100%",
        maxWidth: isMobile ? "50%" : "210px",
      }}
    >
      <div
        className="card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100"
        style={{ cursor: "pointer" }}
        onClick={() => viewDetail(product)}
      >
        <div className="product-image text-center position-relative">
          <img
            src={product.PUJA_IMAGE || placeholderImg}
            alt={product.PUJA_NAME}
            className="img-fluid rounded w-100"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = placeholderImg;
            }}
            style={{ objectFit: "contain", height: "180px" }}
          />
        </div>
        <div className="product-details text-center d-flex align-item-center justify-content-center flex-column flex-grow-1 p-2 m-0">
          <h6 style={{ fontSize: "18px", color: "#8f3246", fontWeight: "600" }}>
            {product.PUJA_NAME}
          </h6>
          <div className="prod-details d-flex align-items-center flex-column">
            <span style={{ fontSize: "16px", whiteSpace: "nowrap" }}>
              ₹
              {status
                ? Math.round(
                  product.OnlinePujaPrice - product.OnlinePujaDiscountAmount
                )
                : Math.round(product.PUJA_PRICE - product.DiscountAmount)}
            </span>
            <span
              style={{
                whiteSpace: "nowrap",
                color: "#a52444",
                fontSize: "15px",
              }}
            >
              View Details <i className="icon-right-arrow"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  );

  const handleCatChange = (category) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (categoryListRef.current) {
      productListRef?.current?.scrollTo({ top: 0, behavior: "smooth" });
    }
    setCatID(category.PUJACAT_ID);
    setSelectedCatId(category.PUJACAT_ID);
    sessionStorage.setItem("selectedCatId", category?.PUJACAT_ID);
  };

  const HandlePujaTypeChange = (value) => {
    if (value === "offline") {
      setPujaStatus(false);
      setStatus(false);
    } else {
      setPujaStatus(true);
      setStatus(true);
    }

  };


  console.log("selectedCatId", selectedCatId)
  return (
    <>
      <section className="page-header" style={{ height: isMobile && "225px" }}>
        <div className="page-header__bg"></div>
        <div className="container">
          <h2 className="page-header__title bw-split-in-left">Book Puja</h2>
        </div>
      </section>

      <div className="main py-4">
        <div className="container px-3 px-md-4">
          <div className="row gx-4 gy-4">
            <div className="breadcrumbMobile" style={{ padding: "8px" }}>
              <Breadcrumbs />
            </div>

            {!isMobile ? (
              <div className="left col-md-3 col-sm-4">
                <div className=" align-items-center gap-4 ">
                  <h4
                    className="custom-list-item clearfix"
                    style={{
                      fontFamily: "poppins",
                      fontSize: "20px",
                      borderBottom: "1px solid lightgray",
                      textTransform: "none",
                      padding: "12px",
                    }}
                  >
                    Puja Type
                  </h4>

                  <label className="d-flex align-items-center gap-1 px-3">
                    <input
                      type="checkbox"
                      checked={!pujaStatus}
                      onChange={() => HandlePujaTypeChange("offline")}
                    />
                    Offline Puja
                  </label>

                  <label className="d-flex align-items-center gap-1 px-3">
                    <input
                      type="checkbox"
                      checked={pujaStatus}
                      onChange={() => HandlePujaTypeChange("online")}
                    />
                    Online Puja
                  </label>
                </div>
                <div>
                  <h4
                    className="custom-list-item clearfix"
                    style={{
                      fontFamily: "poppins",
                      fontSize: "20px",
                      borderBottom: "1px solid lightgray",
                      textTransform: "none",
                      padding: "12px",
                    }}
                  >
                    Puja Category
                  </h4>

                  {/* Scrollable wrapper */}
                  <div
                    ref={categoryListRef}

                    className="scrollable-category"
                    style={{
                      maxHeight:
                        pujaListData?.length <= 6
                          ? "25em"
                          : pujaListData?.length <= 10
                            ? "50em"
                            : pujaListData?.length <= 25
                              ? "90em"
                              : pujaListData?.length <= 45
                                ? "120em"
                                : "150em",
                      overflowY: "auto",
                      paddingRight: "5px",
                    }}



                  >
                    <ul className="margin-bottom-25 sidebar-menu list-unstyled">
                      {myBookPanditData?.length > 0 ? (
                        myBookPanditData.map((category, index) => (
                          <li className="list-group-item clearfix" key={index}>
                            <Link
                              to="#"
                              onClick={() => handleCatChange(category)}
                              className={`d-flex align-items-center ${selectedCatId === category.PUJACAT_ID ? "active" : ""}`}
                              style={{ textWrap: "nowrap" }}
                            >
                              <i className="fa fa-angle-right me-2"></i>
                              {category.PUJACAT_NAME?.length > 30 ? (
                                <Tooltip title={category.PUJACAT_NAME}>
                                  {`${category.PUJACAT_NAME.substring(0, 19)}...`}
                                </Tooltip>
                              ) : (
                                category.PUJACAT_NAME
                              )}
                            </Link>
                          </li>
                        ))
                      ) : (
                        <li className="list-group-item">No categories available</li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <Select
                styles={customSelectStyles}
                options={myBookPanditDataMobile}
                placeholder="Select Category"
                value={myBookPanditDataMobile.find(
                  (option) => option.value === catID
                )}
                onChange={(selectedOption) => {
                  setCatID(selectedOption.value);
                  setSelectedCatId(selectedOption.value);
                }}
              />
            )}

            {/* Product List */}
            <div className="right col-md-9 col-sm-8 ">
              {pujaListData?.length !== 0 ? (
                <div
                  className="row w-100"
                  style={{ justifyContent: "flex-start" }}
                  ref={productListRef}
                >
                  {pujaListData
                    ?.filter(
                      (product) =>
                        search === "" ||
                        product.PUJA_NAME.toLowerCase().includes(search.toLowerCase())
                    )
                    .map((product) => (
                      <ProductCard
                        key={product.PUJA_ID}
                        product={product}
                        viewDetail={viewDetail}
                        placeholderImg={placeholderImg}
                      />
                    ))}
                </div>
              ) : !loader ? (
                <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
                  <img
                    src={Batuk}
                    alt="Empty Cart"
                    className="img-fluid mb-3"
                    style={{ maxWidth: "200px" }}
                  />
                  <h5 className="fw-bold text-center">
                    No services available for this category
                  </h5>
                  <p className="text-muted">Please explore our other categories.</p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default BookPandit;
